import { message } from "antd";
import { AnyAction } from "redux";
import { createAction } from "redux-actions";
import { ThunkDispatch } from "redux-thunk";
import { isHasBasicInfo } from "../../../javascripts/generic";
import { post, url, postNoToken } from "../../../javascripts/http";
import { RootState } from "../../reducers";
import { actionLogoutSuccess } from "../user";
import _ from 'lodash'
import { ExaminationService, ExportExaminationReportRequest, ListReportsRequest } from "../../../api/sennotech/scanner/v2/examination";
import { SennoException } from "../../../api/grpc";
import i18n from "../../../i18n";
import { Language } from "../../../api/sennotech/scanner/v2/type";
import moment from "moment";

const examinationService = new ExaminationService(url, post)
const examinationServiceNoToken = new ExaminationService(url, postNoToken)

let language = Language.ZH;
if(i18n.language == "en") {
    language = Language.EN;
}

// 机构 报告列表
export function actionGetReportListEntryIns (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            let orgId = getState().user.orgId;
            let reqData: ListReportsRequest = {
                institutionId: +orgId,
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
                language: language
            }
            if(data.storeName) {
                reqData.storeName = data.storeName;
            }
            if(data.nickname) {
                reqData.nickname = data.nickname.trim();
            }
            if(data.mobileNumber) {
                reqData.mobileNumber = data.mobileNumber.trim();
            }

            let res = await examinationService.listReports(reqData)
            
            dispatch(actionGetReportListEntryInsSuccess({
                data: res
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYINS_SUCCESS = 'SILIZHU.ACTION_GETREPORTLISTENTRYINS_SUCCESS'

export interface ActionGetReportListEntryInsPayload {
    data: any
}

export const actionGetReportListEntryInsSuccess = createAction(
    ACTION_GETREPORTLISTENTRYINS_SUCCESS,
    (payload: ActionGetReportListEntryInsPayload) => {
        return payload;
    }
)


// 机构 报告列表 分析中 数据采集中 5s 拉取数据
export function actionGetReportListEntryInsByStatus () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        try {
           
            let data = getState().silizhuReport.reportList || {};
            const reportList = data.reports || [];
            if(!reportList.length) return;

            let isProcessing = false;
            reportList.map((item) => {
                if(item.state === 'PROCESSING') {
                    isProcessing = true;
                }
            })
            if(!isProcessing) return;

            let orgId = getState().user.orgId;
            let res = await examinationService.listReports({
                institutionId: +orgId,
                pageNum: data.pageNum,
                pageSize: data.pageSize,
                language: language
            })

            dispatch(actionGetReportListEntryInsByStatusSuccess({
                data: res
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYINSBYSTATUS_SUCCESS = 'SILIZHU.ACTION_GETREPORTLISTENTRYINSBYSTATUS_SUCCESS'

export interface ActionGetReportListEntryInsByStatusPayload {
    data: any
}

export const actionGetReportListEntryInsByStatusSuccess = createAction(
    ACTION_GETREPORTLISTENTRYINSBYSTATUS_SUCCESS,
    (payload: ActionGetReportListEntryInsByStatusPayload) => {
        return payload;
    }
)

// 报告详情
export function actionGetReportDetail (ticket) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('数据加载中...', 0);
        try {

            dispatch(actionGetReportDetailSuccess({
                data: {},
            }))

            let res = await examinationServiceNoToken.getReportByTicket({
                ticket: ticket,
                language: language
            });

            dispatch(actionGetReportDetailSuccess({
                data: res
            }))
            message.destroy()
        } catch (error: any) {
            message.destroy()
            let sennoError = new SennoException(error.response ? error.response.headers : {})
            message.error("数据加载失败: " + sennoError.message, 10)
            console.log({error})
        }
       
    }
}

export const ACTION_GETREPORTDETAIL_SUCCESS = 'SILIZHU.ACTION_GETREPORTDETAIL_SUCCESS'

export interface ActionGetReportDetailPayload {
    data: any
}

export const actionGetReportDetailSuccess = createAction(
    ACTION_GETREPORTDETAIL_SUCCESS,
    (payload: ActionGetReportDetailPayload) => {
        return payload;
    }
)

// 报告详情 分析中 4s 拉取数据
export function actionGetReportDetailByStatus (ticket) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {


            const report = getState().silizhuReport.reportDetail || {};
            const header = report.header;
            if(!header.ticket ||
                ((header.state === "SUCCESS" || header.state === "FAIL"))) return ;
            
            let res = await examinationServiceNoToken.getReportByTicket({
                ticket: ticket,
                language: language
            });

            dispatch(actionGetReportDetailByStatusSuccess({
                data: res
            }))
           
        } catch (error) {
            console.log({error})
        }
       
    }
}

export const ACTION_GETREPORTDETAILBYSTATUS_SUCCESS = 'SILIZHU.ACTION_GETREPORTDETAILBYSTATUS_SUCCESS'

export interface ActionGetReportDetailByStatusPayload {
    data: any
}

export const actionGetReportDetailByStatusSuccess = createAction(
    ACTION_GETREPORTDETAILBYSTATUS_SUCCESS,
    (payload: ActionGetReportDetailByStatusPayload) => {
        return payload;
    }
)



// 商家 报告列表
export function actionGetReportListEntryMerchant (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        message.loading('数据加载中...', 0);
        try {

            let orgId = getState().user.orgId;
            let reqData: ListReportsRequest = {
                storeId: +orgId,
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
                language: language
            }
            if(data.nickname) {
                reqData.nickname = data.nickname.trim();
            }
            if(data.mobileNumber) {
                reqData.mobileNumber = data.mobileNumber.trim();
            }

            let res = await examinationService.listReports(reqData)
            
            dispatch(actionGetReportListEntryMerchantSuccess({
                data: res
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS = 'SILIZHU.ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS'

export interface ActionGetReportListEntryMerchantPayload {
    data: any
}

export const actionGetReportListEntryMerchantSuccess = createAction(
    ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS,
    (payload: ActionGetReportListEntryMerchantPayload) => {
        return payload;
    }
)

// 商家 报告列表 分析中 数据采集中 5s 拉取数据
export function actionGetReportListEntryMerchantByStatus () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return false;
        }
        try {
           
            let data = getState().silizhuReport.reportList || {};
            const reportList = data.reports || [];
            if(!reportList.length) return;

            let isProcessing = false;
            reportList.map((item) => {
                if(item.state === 'PROCESSING') {
                    isProcessing = true;
                }
            })
            if(!isProcessing) return;

            let orgId = getState().user.orgId;
            let res = await examinationService.listReports({
                storeId: +orgId,
                pageNum: data.pageNum,
                pageSize: data.pageSize,
                language: language
            })

            dispatch(actionGetReportListEntryMerchantByStatusSuccess({
                data: res
            }))
        } catch (error) {
            console.log(error)
        }
        message.destroy();
    }
}

export const ACTION_GETREPORTLISTENTRYMERCHANTBYSTATUS_SUCCESS = 'SILIZHU.ACTION_GETREPORTLISTENTRYMERCHANTBYSTATUS_SUCCESS'

export interface ActionGetReportListEntryMerchantByStatusPayload {
    data: any
}

export const actionGetReportListEntryMerchantByStatusSuccess = createAction(
    ACTION_GETREPORTLISTENTRYMERCHANTBYSTATUS_SUCCESS,
    (payload: ActionGetReportListEntryInsByStatusPayload) => {
        return payload;
    }
)

//保存报告结论
export function actionSaveReportRemark (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading(i18n.t('dataSaving'), 0);
        try {

            await examinationServiceNoToken.updateExaminationRemark({
                remark: data.remark,
                ticket: data.ticket,
            })
            
            dispatch(actionSaveReportRemarkSuccess({
                data: '',
            }))
            message.destroy();
            message.success(i18n.t('saveSuccess'), 6);
        } catch (error) {
            message.error(i18n.t('saveFail'), 6)
        }
        
    }
}

export const ACTION_SAVEREPORTREMARK_SUCCESS = 'USER.ACTION_SAVEREPORTREMARK_SUCCESS'

export interface ActionSaveReportRemarkPayload {
    data: any
}

export const actionSaveReportRemarkSuccess = createAction(
    ACTION_SAVEREPORTREMARK_SUCCESS,
    (payload: ActionSaveReportRemarkPayload) => {
        return payload;
    }
)

//导出数据 
export function actionExportData (data: ExportExaminationReportRequest) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading(i18n.t('exporting'), 0);
        try {

            let res = await examinationService.exportExaminationReport(data)
            message.destroy();
            if(res.examinationDataExcel) {
                let bstr = window.atob(res.examinationDataExcel);
                let l = bstr.length;
                let uint8Arr = new Uint8Array(l)
                while(l--) {
                    uint8Arr[l] = bstr.charCodeAt(l)
                }
                let blob = new Blob([uint8Arr]);
                if('download' in document.createElement('a')) {
                    
                    let a = document.createElement('a');
                    a.style.display = "none";
                    a.href = window.URL.createObjectURL(blob);
                    
                    let startStr = "";
                    let endStr = "";
                    if(data.startTimestamp) {
                        startStr = moment(data.startTimestamp).format('YYYYMMDDHHmm');
                    }
                    if(data.endTimestamp) {
                        endStr = moment(data.endTimestamp).format('YYYYMMDDHHmm');
                    }

                    if(startStr || endStr) {
                        a.download = `报告数据${startStr}-${endStr}.xlsx`;  
                    }
                    else if(data.examineeId){
                        let examineeDetail = getState().silizhuExaminee.examineeDetail || {};
                        let examinee = examineeDetail.examinee || {};
                        a.download = `报告数据-${examinee.nickname}.xlsx`;
                    }
                    else {
                        a.download = `报告数据.xlsx`;
                    }
                    a.click()
                }
                else {
                    message.error(i18n.t('exportFail'), 6)
                }
            }
           
            
            dispatch(actionExportDataSuccess({
                data: '',
            }))
        } catch (error: any) {
            let sennoError = new SennoException( error.response ? error.response.headers : {});
            if(+sennoError.code === 1340020) {
                message.error(i18n.t("exportDataMoreThan100"), 12)
            }
            message.error(i18n.t('exportFail'), 6)
        }
        
    }
}

export const ACTION_EXPORTDATA_SUCCESS = 'USER.ACTION_EXPORTDATA_SUCCESS'

export interface ActionExportDataPayload {
    data: any
}

export const actionExportDataSuccess = createAction(
    ACTION_EXPORTDATA_SUCCESS,
    (payload: ActionExportDataPayload) => {
        return payload;
    }
)


//导出扫脚stl 
export function actionExportFeetStl (ticket: string) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading(i18n.t('exporting'), 0);
        try {

            let res = await examinationService.exportFootShapeModel({
                ticket: ticket
            })
            message.destroy();
           
            if(res.footShapeModelZip) {
                if('download' in document.createElement('a')) {
                    let a = document.createElement('a');
                    a.style.display = "none";
                    a.href = res.footShapeModelZip;
                    a.click()
                }
                else {
                    message.error(i18n.t('exportFail'), 6)
                }
            }
            
            dispatch(actionExportFeetStlSuccess({
                data: '',
            }))
        } catch (error) {
            message.error(i18n.t('exportFail'), 6)
        }
        
    }
}

export const ACTION_EXPORTFEETSTL_SUCCESS = 'USER.ACTION_EXPORTFEETSTL_SUCCESS'

export interface ActionExportFeetStlPayload {
    data: any
}

export const actionExportFeetStlSuccess = createAction(
    ACTION_EXPORTFEETSTL_SUCCESS,
    (payload: ActionExportFeetStlPayload) => {
        return payload;
    }
)